export const ALL_VALUE = 'All';
